import React, { useContext } from 'react';
import {
    DateInput as RADateInput,
    TextInput as RATextInput,
    SelectInput as RASelectInput,
    NumberInput as RANumberInput,
    BooleanInput as RABooleanInput,
    ArrayInput as RAArrayInput,
    AutocompleteInput as RAAutocompleteInput,
    RadioButtonGroupInput as RARadioButtonGroupInput,
    SelectArrayInput as RASelectArrayInput,
    DateTimeInput as RADateTimeInput,
    ReferenceArrayInput as RAReferenceArrayInput,
    Loading

} from 'react-admin';
import { ReadOnlyContext } from '../context/ReadOnlyContext';
import { RichTextInput as RARichTextInput, RichTextInputToolbar } from 'ra-input-rich-text';

export const TextInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RATextInput disabled={readonly} {...props} />;
};

export const DateInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RADateInput disabled={readonly} {...props} />;
};

export const DateTimeInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RADateTimeInput disabled={readonly} {...props} />;
};

export const SelectInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RASelectInput disabled={readonly} {...props} />;
};

export const NumberInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RANumberInput disabled={readonly} {...props} />;
};

export const BooleanInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RABooleanInput disabled={readonly} {...props} />;
};

export const AutocompleteInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RAAutocompleteInput {...props}  disabled={readonly} />;
};

export const ArrayInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return (
        <RAArrayInput disabled={readonly} {...props}>
            {props.children}
        </RAArrayInput>
    );
};

export const RichTextInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RARichTextInput toolbar={<RichTextInputToolbar size="small" />} readOnly={readonly} {...props} />;
};

export const RadioButtonGroupInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RARadioButtonGroupInput disabled={readonly} {...props} />;
};

export const SelectArrayInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RASelectArrayInput disabled={readonly} {...props} />;
};
export const SelectReferenceArrayInput = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RAReferenceArrayInput disabled={readonly} {...props} />;
};

